import React from 'react';
import { useTheme } from '@material-ui/core';

const ConfirmationCheck = () => {
  const {
    palette: {
      error: { contrastMain },
      common: { white },
    },
  } = useTheme();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill={contrastMain} />
      <path
        d="M19.4657 11.3382C18.4854 10.4354 17.362 9.72854 16.0954 9.2177C14.8284 8.70687 13.4628 8.45146 11.9987 8.45146C11.7695 8.45146 11.55 8.46049 11.3402 8.47854C11.1299 8.49612 10.9102 8.5168 10.681 8.54056L8.59939 6.59821C9.15958 6.45565 9.71671 6.35158 10.2708 6.28601C10.8243 6.2209 11.4003 6.18835 11.9987 6.18835C13.8066 6.18835 15.4935 6.50317 17.0595 7.1328C18.6254 7.76243 19.9941 8.62371 21.1654 9.71666L19.4657 11.3382ZM16.5629 14.0112C16.3465 13.8211 16.1619 13.6548 16.0091 13.5123C15.8563 13.3697 15.6781 13.1974 15.4744 12.9955L12.7626 10.4829C13.7811 10.5898 14.7263 10.8362 15.5981 11.2221C16.4705 11.6084 17.2441 12.1164 17.9188 12.746L16.5629 14.0112ZM17.8806 19.4997L10.7765 12.8351C10.1781 12.9658 9.63064 13.1587 9.13411 13.4139C8.63759 13.6695 8.19198 13.9874 7.79731 14.3676L6.07856 12.746C6.47323 12.3777 6.89974 12.051 7.35807 11.7659C7.81641 11.4808 8.30657 11.2313 8.82856 11.0175L7.22439 9.52064C6.7024 9.77011 6.22497 10.0434 5.7921 10.3403C5.35923 10.6373 4.93909 10.97 4.53168 11.3382L2.83203 9.71666C3.22671 9.34838 3.64048 9.01266 4.07335 8.70949C4.50622 8.40679 4.96455 8.12476 5.44835 7.86341L3.84418 6.38437L4.97092 5.33301L19.0265 18.4483L17.8806 19.4997ZM11.9987 18.3058L9.30599 15.7754C9.64974 15.4546 10.0508 15.202 10.5091 15.0177C10.9674 14.8338 11.464 14.7418 11.9987 14.7418C12.5334 14.7418 13.0299 14.8338 13.4883 15.0177C13.9466 15.202 14.3477 15.4546 14.6914 15.7754L11.9987 18.3058Z"
        fill={white}
      />
    </svg>
  );
};

export default ConfirmationCheck;
